import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const { google } = useAuth();
  const nav = useNavigate();
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    const sid = m ? decodeURIComponent(m[1]) : null;
    if (!sid) {
      toast.error("Google sign-in was cancelled");
      nav("/login", { replace: true });
      return;
    }
    google(sid)
      .then(() => { toast.success("Signed in with Google"); nav("/", { replace: true }); })
      .catch(() => { toast.error("Google sign-in failed"); nav("/login", { replace: true }); });
  }, [google, nav]);

  return (
    <div className="min-h-screen bg-[#09090B] flex flex-col items-center justify-center gap-3">
      <Loader2 className="w-6 h-6 text-blue-500 animate-spin" />
      <p className="font-mono text-xs text-zinc-500">Completing Google sign-in…</p>
    </div>
  );
}
